import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import { Link } from 'react-router-dom';
interface UiValeur {
    id?: number;
    nom?: string;
    titre?: string;
    slug?: string;
    description?: string;
    icone?: string;
    createdAt?: string;
    updatedAt?: string;
}
export default function Programme() {
    const [listData, setDataList] = useState<UiValeur[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchListData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiValeur>('/fetch_service_data');
            setDataList(res.data);

        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchListData();
    }, []);

    return (
        <div className="section panel overflow-hidden">
            <div className="section-outer panel py-4 md:py-6 lg:py-8 xl:py-9 bg-white dark:bg-gray-900">
                <div className="container max-w-2xl p-0 sm:px-2 lg:px-4 xl:px-0">
                    <div className="section-inner">
                        <div className="block-layout grid-layout vstack gap-3 sm:gap-4 xl:gap-5 panel">
                            <div className="block-header px-2 lg:px-0 text-center">
                                <h2 className="h4 md:h3 m-0">
                                    <i className="fas fa-calendar text-primary me-2"></i>
                                    <span>Nos Programmes et Services</span>
                                </h2>
                                <p className="fs-6 mt-2 text-gray-600 dark:text-gray-400">Une formation complète pour les champions de demain</p>
                            </div>
                            <div className="block-content container max-w-3xl">
                                <div className="row child-cols-12 sm:child-cols-2 lg:child-cols-4 g-4">

                                    {
                                        listData.length > 0 ? (
                                            listData.map(item => (
                                                <div className="text-center" key={item.id}>
                                                    <div className="
                                                        panel p-5 bg-white dark:bg-gray-900 rounded-xl 
                                                        shadow-md hover:shadow-xl transition-all duration-300 
                                                        
                                                        vstack gap-1 h-100 relative overflow-hidden group
                                                    ">

                                                        {/* --- Accent décoratif --- */}
                                                        <span className="
                                                            absolute top-0 left-0 w-full h-1 bg-primary 
                                                            scale-x-0 group-hover:scale-x-100 
                                                            origin-left transition-transform duration-500
                                                        "></span>

                                                        {/* --- Icône --- */}
                                                        <div className="w-80px h-80px bg-primary bg-opacity-10 rounded-circle hstack justify-center items-center mx-auto">
                                                            <i className={`${item.icone} text-primary text-2xl`}></i>
                                                        </div>

                                                        {/* --- Nom du service --- */}
                                                        <h3 className="h4 font-bold m-0 text-gray-900 dark:text-white group-hover:text-primary transition-colors duration-300">
                                                            {item.nom}
                                                        </h3>

                                                        {/* --- Sous-titre --- */}
                                                        <p className="fs-6 m-0 text-gray-600 dark:text-gray-300 text-truncate-2">
                                                            {item.titre}
                                                        </p>

                                                        {/* --- CTA Lien --- */}
                                                        <Link
                                                            to={`/service/${item.slug}`}
                                                            className="
                                                                mt-2 inline-flex items-center gap-2
                                                                text-primary font-semibold fs-6 text-none
                                                                hover:gap-3 transition-all duration-300
                                                            "
                                                        >
                                                            Lire plus
                                                            <i className="fa fa-arrow-right text-sm"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p>Aucun choix disponible</p>
                                        )
                                    }




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
